import { Component, Entity2D } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';
import { PiggyBankBlockProps } from './PiggyBankBlock';
import { PiggyBankBlockView } from './PiggyBankBlockView';

export type PiggyBankBlockComponentOptions = {
  props: PiggyBankBlockProps;
  option?: number;
};

export class PiggyBankBlockComponent implements Component {
  public static readonly NAME = 'blockPiggyBank';

  public entity!: Entity2D;
  public view!: PiggyBankBlockView;
  private props!: PiggyBankBlockProps;

  public init(args: PiggyBankBlockComponentOptions): void {
    // get option def
    const optionDef = args.props.options?.[
      args.option || 0
    ] as CountBlockOptionDef;

    this.props = args.props;

    // create view
    this.view = new PiggyBankBlockView(args.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }
}
